export enum userNotificationStatus {
	Info = "info",
	Success = "success",
	Error = "error",
	Warning = "warning",
}
